/**
 * Route Definitions
 *
 * All application routes for the authentication flow
 */

import type { RouteRecordRaw } from 'vue-router';

/**
 * Auth routes
 */
export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/login/email',
  },
  {
    path: '/login/email',
    name: 'email-input',
    component: () => import('@/views/auth/EmailInputView.vue'),
    meta: {
      title: 'Sign In',
      requiresAuth: false,
    },
  },
  {
    path: '/login/password',
    name: 'password',
    component: () => import('@/views/auth/PasswordView.vue'),
    meta: {
      title: 'Enter Password',
      requiresAuth: false,
      requiresEmail: true, // User must have entered email first
    },
  },
  {
    path: '/login/new-password',
    name: 'new-password',
    component: () => import('@/views/auth/NewPasswordView.vue'),
    meta: {
      title: 'Set New Password',
      requiresAuth: false,
      requiresEmail: true,
    },
  },
  {
    path: '/login/2fa',
    name: 'two-factor',
    component: () => import('@/views/auth/TwoFactorView.vue'),
    meta: {
      title: 'Two-Factor Authentication',
      requiresAuth: false,
      requiresEmail: true,
    },
  },
  {
    path: '/login/mfa-setup',
    name: 'mfa-setup',
    component: () => import('@/views/auth/MFASetupView.vue'),
    meta: {
      title: 'Setup Two-Factor Authentication',
      requiresAuth: true, // User must be authenticated
    },
  },
  {
    path: '/login/success',
    name: 'success',
    component: () => import('@/views/auth/SuccessView.vue'),
    meta: {
      title: 'Success',
      requiresAuth: true, // User must be authenticated
    },
  },
  {
    path: '/api/auth/callback',
    name: 'callback',
    component: () => import('@/views/auth/CallbackView.vue'),
    meta: {
      title: 'Processing...',
      requiresAuth: false,
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/auth/LogoutView.vue'),
    meta: {
      title: 'Signing Out',
      requiresAuth: false,
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/ResetPasswordView.vue'),
    meta: {
      title: 'Reset Password',
      requiresAuth: false,
    },
  },
];

/**
 * All application routes
 */
export const routes: RouteRecordRaw[] = [
  ...authRoutes,
  // 404 catch-all route
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login/email',
  },
];